// Fetch Shopify-rendered card content so prices, badges and images stay authoritative.
if (!customElements.get('nv-card-colors')) {
  customElements.define('nv-card-colors', class extends HTMLElement {
    connectedCallback() { this.onclick = event => this.switchColor(event); }
    disconnectedCallback() { this.request?.abort(); }
    async switchColor(event) {
      event.stopPropagation();
      const link = event.target.closest('a');
      if (!link || link.classList.contains('nv-card-colors__more') || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
      event.preventDefault();
      if (link.hasAttribute('aria-current')) return;
      const card = this.closest('product-card');
      if (!card) return;
      this.request?.abort();
      const controller = this.request = new AbortController();
      card.setAttribute('aria-busy', 'true');
      this.querySelector('[role="status"]')?.remove();
      const url = new URL(link.href);
      url.searchParams.set('section_id', 'nv-card-color-render');
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Card fetch failed');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = document.querySelector('[data-card-color-payload]');
        if (!payload?.querySelector('slideshow-component') || !payload.querySelector('nv-card-colors')) throw new Error('Incomplete card');
        if (controller.signal.aborted || !this.isConnected) return;
        // Replace a cloned card so all Horizon components reconnect with fresh references.
        const host = card.parentElement.matches('product-card-link') ? card.parentElement : card;
        const replacement = host.cloneNode(true);
        const next = replacement.matches('product-card') ? replacement : replacement.querySelector('product-card');
        next.dataset.productId = payload.dataset.productId;
        next.removeAttribute('aria-busy');
        for (const ref of ['productCardLink','cardGalleryLink','productTitleLink']) {
          const anchor = next.querySelector(`[ref="${ref}"]`);
          if (anchor) anchor.href = payload.dataset.url;
        }
        const title = next.querySelector('[ref="productTitleLink"] p');
        if (title) title.textContent = payload.dataset.title;
        next.querySelector('.product-card__link .visually-hidden').textContent = payload.dataset.title;
        const gallery = next.querySelector('.card-gallery');
        gallery.dataset.productId = payload.dataset.productId;
        gallery.querySelector('[ref="cardGalleryLink"]').setAttribute('aria-label', payload.dataset.title);
        gallery.querySelector('slideshow-component').replaceWith(payload.querySelector('slideshow-component'));
        gallery.querySelector('.product-badges-global')?.replaceWith(payload.querySelector('.product-badges-global'));
        const quickAdd = next.querySelector('quick-add-component');
        const incomingQuickAdd = payload.querySelector('quick-add-component');
        if (quickAdd && incomingQuickAdd) quickAdd.replaceWith(incomingQuickAdd);
        else quickAdd?.remove();
        const price = next.querySelector('product-price');
        const incomingPrice = payload.querySelector('product-price');
        if (price) {
          price.innerHTML = incomingPrice.innerHTML;
          for (const [key,value] of Object.entries(incomingPrice.dataset)) price.dataset[key] = value;
        }
        next.querySelectorAll('.product-grid-view-zoom-out--details h3').forEach(el => el.textContent = payload.dataset.title);
        const wishlist = next.querySelector('[data-wish-handle]');
        const incomingWishlist = payload.querySelector('[data-wish-handle]');
        if (wishlist && incomingWishlist) wishlist.replaceWith(incomingWishlist);
        next.querySelector('nv-card-colors').replaceWith(payload.querySelector('nv-card-colors'));
        if (replacement.matches('product-card-link')) {
          replacement.dataset.productId = payload.dataset.productId;
          replacement.dataset.featuredMediaUrl = payload.dataset.featuredMediaUrl;
        }
        host.replaceWith(replacement);
        next.querySelector('nv-card-colors [aria-current]')?.focus({preventScroll:true});
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) next.animate([{opacity:.55},{opacity:1}],{duration:220,easing:'ease-out'});
      } catch (error) {
        if (error.name === 'AbortError') return;
        const status = window.document.createElement('span');
        status.role = 'status';
        status.textContent = 'Barvu se nepodařilo načíst. Zkuste to znovu.';
        this.append(status);
      } finally {
        if (this.request === controller) card.removeAttribute('aria-busy');
      }
    }
  });
}
// Animate the existing gallery switch without changing its swipe/navigation logic.
if (!window.nvCardPolish) {
  window.nvCardPolish = true;
  for (const type of ['pointerover', 'pointerout']) document.addEventListener(type, event => {
    if (event.pointerType !== 'mouse' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const gallery = event.target.closest?.('product-card .card-gallery');
    if (!gallery || gallery.contains(event.relatedTarget)) return;
    gallery.querySelector('slideshow-component')?.animate([{opacity:.65},{opacity:1}], {duration:240,easing:'ease-out'});
  });
}
